import { _js } from '@ifixit/utils/localize';
import { FaIcon } from '@ifixit/ui/components/icon';
import { TiptapButton } from '../TiptapButton';
import { useEditorContext, useEditorSelector } from '../../editor_context';

export const LinkButton = () => {
   const { editor } = useEditorContext();
   const state = useEditorSelector(editor => ({
      isActive: editor.isActive('link'),
      isDisabled: !editor.can().editLink(),
   }));

   if (!state) {
      return null;
   }

   return (
      <TiptapButton
         onClick={() => editor.chain().focus().editLink().run()}
         isDisabled={state.isDisabled}
         isActive={state.isActive}
         icon={<FaIcon name="link" />}
         title={_js('Insert a link')}
         shortcut={'k'}
      />
   );
};
